import { createPortal } from "react-dom";
import { Toast } from "./Toast";
import { useToastStore } from "@/shared/stores/toastStore";

export const ToastContainer = () => {
  const { toasts, handleClose } = useToastStore();

  return createPortal(
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => handleClose(toast.id)}
          isClosing={toast.isClosing || false}
        />
      ))}
    </>,
    document.body,
  );
};
